import React from "react";
import { graphql } from "gatsby";
import Layout from "~/components/layout";
import BannerComponent from "../components/banner";
import AnounceComponent from "../components/anounce";
import SubAnounceComponent from "../components/subanounce";
import styled from "styled-components";
import ContactComponent from "../components/contact-component";
import Fade from 'react-reveal/Fade';

const WrapperContent = styled.div``;

const ContactPage = ({ data }) => {
  const pageName = "live22";
  const textBtn = "คลิกที่นี่";
  const valueKey = "/contact";
  const bannerList = data.datoCmsLive22.banner;
  const anounce = data.datoCmsAnounceSlider.anounceText;
  const subAnounce = {
    header: data.datoCmsContact.contactHeader,
    content: data.datoCmsContact.contactContent,
  }
  const contactDetail = data.datoCmsContact.contactDetail;

  return (
    <Layout pageName={pageName}>
      <Fade bottom>
        <BannerComponent bannerList={bannerList} pageName={pageName} />
      </Fade>
      <WrapperContent className="w-full lg:container mx-auto">
        <Fade bottom>
          <AnounceComponent anounce={anounce} pageName={pageName} />
        </Fade>
        <Fade bottom>
          <SubAnounceComponent subAnounce={subAnounce} pageName={pageName} />
        </Fade>
        <ContactComponent
          data={contactDetail}
          pageName={pageName}
          textBtn={textBtn}
          valueKey={valueKey}
        />
      </WrapperContent>
    </Layout>
  );
};

export const query = graphql`
  query ContactPageTemplate {
    datoCmsAnounceSlider {
      anounceText
    }
    datoCmsLive22 {
      banner {
        url(imgixParams: {auto: "format", q: 90})
      }
    }
    datoCmsContact {
    contactDetail {
      title
      link
      providerName
      providerLogo {
        url(imgixParams: {auto: "format", q: 90})
      }
    }
      contactHeader
      contactContent
    }
  }
`;

export default ContactPage;
